export const actionButton = {
  buttonWidthVal: 46,
  buttonMarginMobile: '5px',
};

export const PRODUCT_ALERT_MODAL_ID = 'product-alert-modal';
